export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
export const API_SHOP_LIST = "/mock/shop";

export const DEFAULT_PAGE = 1;
export const DEFAULT_ITEMS_PER_PAGE = 20;
